export const APP_LANGUAGES = ["pl", "en"] as const;

export type AppLanguage = (typeof APP_LANGUAGES)[number];

export const DEFAULT_APP_LANGUAGE: AppLanguage = "pl";

export const isAppLanguage = (value: unknown): value is AppLanguage => value === "pl" || value === "en";

export const getAppLanguage = (value: unknown): AppLanguage => (isAppLanguage(value) ? value : DEFAULT_APP_LANGUAGE);
